(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(arr);
}


function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
}


function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $c50969dc1df61e8b$export$7e0947b5ad3404e2)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Game.DEFAULT_STATE;
        (0, $8713978b2328d32b$export$2996f80ef42b8419)(this, Game);
        this.initialState = initialState;
        this.state = this.deepCloneArray(this.initialState);
        this.status = Game.STATUS_IDLE;
        this.score = 0;
    }
    (0, $4fc75ccb937ab1df$export$d60067ff2358eee8)(Game, [
        {
            key: "deepCloneArray",
            value: function deepCloneArray(arr) {
                return arr.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
                });
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.state[i].filter(function(val) {
                        return val !== 0;
                    }); // [2, 2, 4]
                    for(var j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                        row[j] *= 2;
                        row[j + 1] = 0; // [4, 0, 4]
                        if (row[j] === Game.WIN_NUMBER) _this.status = Game.STATUS_WIN;
                        _this.score += row[j];
                    }
                    row = row.filter(function(val) {
                        return val !== 0;
                    }); // [4, 4]
                    while(row.length < _this.state[i].length)row.push(0);
                     // [4, 4, 0, 0]
                    _this.state[i] = row;
                };
                // [2, 2, 4, 0]
                if (this.status === Game.STATUS_WIN || this.status === Game.STATUS_LOSE || this.status === Game.STATUS_IDLE) return;
                var prevState = JSON.stringify(this.state);
                for(var i = 0; i < this.state.length; i++)_loop(i);
                if (prevState !== JSON.stringify(this.state)) this.addRandomTile();
                if (!this.movesAvailable()) this.status = Game.STATUS_LOSE;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var row = _this.state[i].filter(function(val) {
                        return val !== 0;
                    }); // [4, 2, 2]
                    for(var j = row.length - 1; j > 0; j--)if (row[j] === row[j - 1]) {
                        row[j] *= 2;
                        row[j - 1] = 0;
                        if (row[j] === Game.WIN_NUMBER) _this.status = Game.STATUS_WIN;
                        _this.score += row[j]; // [4, 0, 4]
                    }
                    row = row.filter(function(val) {
                        return val !== 0;
                    }); // [4, 4]
                    while(row.length < _this.state[i].length)row.unshift(0);
                     // [0, 0, 4, 4]
                    _this.state[i] = row;
                };
                if (this.status === Game.STATUS_WIN || this.status === Game.STATUS_LOSE || this.status === Game.STATUS_IDLE) return;
                var prevState = JSON.stringify(this.state);
                // [0, 4, 2, 2]
                for(var i = 0; i < this.state.length; i++)_loop(i);
                if (prevState !== JSON.stringify(this.state)) this.addRandomTile();
                if (!this.movesAvailable()) this.status = Game.STATUS_LOSE;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var column = [];
                    for(var row = 0; row < _this.state.length; row++)if (_this.state[row][col] !== 0) column.push(_this.state[row][col]);
                    for(var i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                        column[i] *= 2;
                        column[i + 1] = 0;
                        if (column[i] === Game.WIN_NUMBER) _this.status = Game.STATUS_WIN;
                        _this.score += column[i];
                    }
                    column = column.filter(function(val) {
                        return val !== 0;
                    });
                    while(column.length < _this.state.length)column.push(0);
                    for(var row1 = 0; row1 < _this.state.length; row1++)_this.state[row1][col] = column[row1];
                };
                if (this.status === Game.STATUS_WIN || this.status === Game.STATUS_LOSE || this.status === Game.STATUS_IDLE) return;
                var prevState = JSON.stringify(this.state);
                for(var col = 0; col < this.state[0].length; col++)_loop(col);
                if (prevState !== JSON.stringify(this.state)) this.addRandomTile();
                if (!this.movesAvailable()) this.status = Game.STATUS_LOSE;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var column = [];
                    for(var row = 0; row < _this.state.length; row++)if (_this.state[row][col] !== 0) column.push(_this.state[row][col]);
                    for(var i = column.length - 1; i > 0; i--)if (column[i] === column[i - 1]) {
                        column[i] *= 2;
                        column[i - 1] = 0;
                        if (column[i] === Game.WIN_NUMBER) _this.status = Game.STATUS_WIN;
                        _this.score += column[i];
                    }
                    column = column.filter(function(val) {
                        return val !== 0;
                    });
                    while(column.length < _this.state.length)column.unshift(0);
                    for(var row1 = 0; row1 < _this.state.length; row1++)_this.state[row1][col] = column[row1];
                };
                if (this.status === Game.STATUS_WIN || this.status === Game.STATUS_LOSE || this.status === Game.STATUS_IDLE) return;
                var prevState = JSON.stringify(this.state);
                for(var col = 0; col < this.state[0].length; col++)_loop(col);
                if (prevState !== JSON.stringify(this.state)) this.addRandomTile();
                if (!this.movesAvailable()) this.status = Game.STATUS_LOSE;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = Game.STATUS_PLAYING;
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = this.deepCloneArray(this.initialState);
                this.score = 0;
                this.status = Game.STATUS_IDLE;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyTiles = [];
                for(var i = 0; i < this.state.length; i++){
                    for(var j = 0; j < this.state[i].length; j++)if (this.state[i][j] === 0) emptyTiles.push({
                        x: i,
                        y: j
                    });
                }
                var randomIndex = Math.floor(Math.random() * emptyTiles.length);
                var _emptyTiles_randomIndex = emptyTiles[randomIndex], x = _emptyTiles_randomIndex.x, y = _emptyTiles_randomIndex.y;
                this.state[x][y] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "movesAvailable",
            value: function movesAvailable() {
                for(var i = 0; i < this.state.length; i++)for(var j = 0; j < this.state[i].length; j++){
                    if (this.state[i][j] === 0) return true;
                    if (i > 0 && this.state[i][j] === this.state[i - 1][j]) return true;
                    if (i < this.state.length - 1 && this.state[i][j] === this.state[i + 1][j]) return true;
                    if (j > 0 && this.state[i][j] === this.state[i][j - 1]) return true;
                    if (j < this.state[i].length - 1 && this.state[i][j] === this.state[i][j + 1]) return true;
                }
                return false;
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "WIN_NUMBER", 2048);
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "STATUS_PLAYING", "playing");
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "STATUS_IDLE", "idle");
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "STATUS_LOSE", "lose");
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "STATUS_WIN", "win");
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "DEFAULT_STATE", [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
]);
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$fieldCells = document.querySelectorAll(".field-cell");
$197cd56b15c33885$var$button.addEventListener("click", function() {
    $197cd56b15c33885$var$button.classList.toggle("start");
    $197cd56b15c33885$var$button.classList.toggle("restart");
    if ($197cd56b15c33885$var$button.classList.contains("restart")) {
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$updateGame();
        document.addEventListener("keydown", $197cd56b15c33885$var$handleKeyPress);
    } else {
        $197cd56b15c33885$var$button.textContent = "Start";
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$updateGame();
    }
});
function $197cd56b15c33885$var$handleKeyPress(e) {
    switch(e.key){
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$updateGame();
}
function $197cd56b15c33885$var$updateGame() {
    $197cd56b15c33885$var$updateScore();
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$updateMessage();
}
function $197cd56b15c33885$var$updateScore() {
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$updateBoard() {
    var state = $197cd56b15c33885$var$game.getState();
    for(var i = 0; i < state.length; i++)for(var j = 0; j < state[i].length; j++){
        var cell = $197cd56b15c33885$var$fieldCells[i * state.length + j];
        cell.textContent = state[i][j] === 0 ? "" : state[i][j];
        cell.className = "field-cell";
        if (state[i][j] !== 0) cell.classList.add("field-cell--".concat(state[i][j]));
    }
}
function $197cd56b15c33885$var$updateMessage() {
    var statusGame = $197cd56b15c33885$var$game.getStatus();
    var messageContainer = document.querySelector(".message-container");
    var messages = messageContainer.querySelectorAll(".message");
    messages.forEach(function(message) {
        return message.classList.add("hidden");
    });
    if (statusGame === $3d28d7f1aac198f5$exports.STATUS_LOSE) messageContainer.querySelector(".message-lose").classList.remove("hidden");
    else if (statusGame === $3d28d7f1aac198f5$exports.STATUS_WIN) messageContainer.querySelector(".message-win").classList.remove("hidden");
    else if (statusGame === $3d28d7f1aac198f5$exports.STATUS_IDLE) messageContainer.querySelector(".message-start").classList.remove("hidden");
}

})();
//# sourceMappingURL=index.967fda37.js.map
